import { render } from "./UtenteDetail.vue?vue&type=template&id=897fe714"
import script from "./UtenteDetail.vue?vue&type=script&lang=js"
export * from "./UtenteDetail.vue?vue&type=script&lang=js"

import "./UtenteDetail.vue?vue&type=style&index=0&id=897fe714&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__